// Framework and third-party non-ui
import styled from 'styled-components';

export const StyledEditorContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
